export const trackingEvents = {
  PAGE: {
    VIEWED: 'worker_networks.page.viewed',
  },
}
